import { render, staticRenderFns } from "./lazyblock_qzr_events_list.vue?vue&type=template&id=9c2477ca&scoped=true"
import script from "./lazyblock_qzr_events_list.vue?vue&type=script&lang=js"
export * from "./lazyblock_qzr_events_list.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_qzr_events_list.vue?vue&type=style&index=0&id=9c2477ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2477ca",
  null
  
)

export default component.exports